import React from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import type { BannerFormData } from './types';

interface BannerFormProps {
  index: number;
  formData: BannerFormData;
  updateField: (index: number, field: keyof BannerFormData, value: any) => void;
}

const BannerForm: React.FC<BannerFormProps> = ({ index, formData, updateField }) => {
  return (
    <Row>
      <Col md={12}>
        <Form.Group className="m-3">
          <Form.Label>
            <strong>Title</strong> <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            type="text"
            value={formData.title}
            onChange={(e) => updateField(index, 'title', e.target.value)}
            placeholder="Enter banner title"
            required
            className="bg-white"
          />
        </Form.Group>
        <Form.Group className="m-3">
          <Form.Label>
            <strong>Description</strong>
          </Form.Label>
          <Form.Control
            as="textarea"
            rows={2}
            value={formData.description}
            onChange={(e) => updateField(index, 'description', e.target.value)}
            placeholder="Enter banner description"
            className="bg-white"
          />
        </Form.Group>

        <Form.Group className="m-3">
          <Form.Label>
            <strong>Banner Location</strong>
          </Form.Label>
          <Form.Control
            type="text"
            value={formData.location || '/'}
            onChange={(e) => updateField(index, 'location', e.target.value)}
            placeholder="/"
            className="bg-white"
          />
          <Form.Text className="text-muted">
            Enter the path where this banner should be displayed (e.g., <code>/trend</code> for
            https://skin-seoul.com/trend)
          </Form.Text>
        </Form.Group>

        <Form.Group className="m-3">
          <Form.Label>
            <strong>Link URL to navigate when the image is clicked</strong>
          </Form.Label>
          <Form.Control
            type="url"
            value={formData.linkUrl}
            onChange={(e) => updateField(index, 'linkUrl', e.target.value)}
            placeholder="https://"
            className="bg-white"
          />
        </Form.Group>

        <Row className="m-1">
          <p className=" fw-bold">Display Period</p>
          <Col md={6}>
            <Form.Group className="m-0">
              <Form.Label>
                <strong>From Date</strong> <span className="text-danger">*</span>
              </Form.Label>
              <DatePicker
                selected={formData.fromDate}
                onChange={(date: Date | null) => updateField(index, 'fromDate', date || new Date())}
                className="form-control"
                dateFormat="yyyy-MM-dd"
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group className="m-0">
              <Form.Label>
                <strong>To Date</strong> <span className="text-danger">*</span>
              </Form.Label>
              <DatePicker
                selected={formData.toDate}
                onChange={(date: Date | null) => updateField(index, 'toDate', date || formData.toDate)}
                className="form-control"
                dateFormat="yyyy-MM-dd"
              />
            </Form.Group>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default BannerForm;
